// var headerNav = require('../../shared/headerNav')
// var footer = require('../../shared/footer')
module.exports = {
  url: '/blog-tag/:tag',
  template: require('raw!templates/blog-tag/blog-tag.html'),
  controller: [
    '$scope',
    '$state',
    'store',
    'contentful',
    '$uibModal',
    '$window',
    '$timeout',
    '$sce',
    component
  ],
  params: {
    // category: null
  }
}

function component($scope, $state, store, contentful, $uibModal, $window, $timeout, $sce) {
  $scope.page = 'blog-tag'
  $scope.custom = true
  $scope.custom1 = false
  $scope.custom2 = true
  $scope.slide = {
    'blogNav': true
  }
  var vm = this;

  contentful.entries('content_type=blogTags').then(function(res) {
    $scope.blogTags = res.data.items;
  });

  $scope.tag = $state.params.tag;

  $window.scrollTo(0, 0);

  $scope.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  }

  if ($state.params.obj) {
    $scope.workProject = $state.params.obj
    store.set('workProject', $state.params.obj)
  } else if ($state.params.tag) {
    contentful.entries('content_type=blogPost&fields.tags=' + $state.params.tag).then(function(res) {
      $scope.workProject = res.data.items
      // console.log("blog detail data", $scope.workProject);
    })
  }
  else if (store.get('workProject')) {
    $scope.workProject = store.get('workProject')
  }
  contentful.entries('content_type=blogPost').then(function(res) {
    $scope.allWorkProjects = res.data.items
  })

  contentful.entries('content_type=blogPost').then(function(res) {
    var seoData = res.data.items[0];
    if (seoData.fields.pageTitle) {
      document.title = seoData.fields.pageTitleSeo;
    }
    if (seoData.fields.pageSpecificMetaDescriptionSeo) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.pageSpecificMetaDescriptionSeo;
        }
      }
    }
  });
  contentful.entries('content_type=blogPost').then(function(res) {
    vm.projectGallery = res.data.items[0];
  });

  $scope.selectServiceProvided = function(serviceProvided) {
    $scope.currentServiceProvided = serviceProvided
    $scope.page = $scope.currentServiceProvided
  }
  if ($state.params.tag) {
    $scope.page = $state.params.tag
    $scope.currentServiceProvided = $state.params.tag
    $scope.selectedService = $state.params.tag
    // $scope.selectedService = $state.params.service.fields.contactPerson
    store.set('workService', $scope.selectedService)
  } else if (store.get('selectedWorkService')) {
    $scope.currentServiceProvided = store.get('selectedWorkService')
    $scope.selectedService = $scope.currentServiceProvided
    // $scope.selectedService = $scope.currentServiceProvided.fields.contactPerson

  }

  //// below needed for service subnav to display///////
  $scope.allServices = []
  contentful.entries('content_type=topics&include=3').then(function(res) {
    var items = res.data.items
    angular.forEach(items, function(item) {
      $scope.allServices.push(item)
    })
  })
  $scope.selectService = function(service) {
    $scope.currentService = service
    $scope.page = $scope.currentService
    // $scope.page = $scope.currentService.fields.contactPerson
    $scope.pageSlug = $scope.currentService
  }
  $scope.allWorkProjects = []
  contentful.entries('content_type=workProjects&include=3').then(function(res) {
    $scope.allWorkProjects = res.data.items
  })
  contentful.entries('content_type=topics').then(function(res) {
    $scope.allTags = res.data.items;
  });
  $timeout(function() {
    $('#lightgallery').lightGallery({
        pager: true
      });
    $('.responsive').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800,
      slidesToShow: 4,

      // the magic
      responsive: [
        {

          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            infinite: true
          }

        }, {

          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }

        },
        {

          breakpoint: 400,
          settings: {
            slidesToShow: 1
          }

        },
        {

         breakpoint: 300,
         settings: "unslick" // destroys slick

       }
      ]
    });
  }, 500);
}



/** WEBPACK FOOTER **
 ** ./components/templates/blog-tag/blog-tag.js
 **/